import React, { useEffect } from 'react';

import { LegalDocuments } from '../constants';
import { getUrlForLegalDoc } from '../data/graphql';

/**
 * Redirect mechanism for the old Cardholder Agreement PDF link
 *
 * This is effectively a temporary workaround to use while the old CHA link is
 * still accessible to users via old marketing emails/other outdated sources.
 */
export const RedirectRouter = () => {
  useEffect(() => {
    const url = getUrlForLegalDoc(
      LegalDocuments.PROSPER_CARD_CARDHOLDER_AGREEMENT
    );
    window.location.replace(url);
  }, []);

  // React fragments require at least 2 child elements, used as a placeholder component in App.tsx
  return (
    <>
      {}
      {}
    </>
  );
};
